import React from 'react';
import { HeroFullOverlay } from '@cotyorg/ccx-organism-hero';
import StandardLayout from '../../templates/StandardLayout';

const OurIngredients = () => (
  <StandardLayout>
    <div className="our-ingredients-page">
      <div className="grid-container">
        <div className="grid-x grid-margin-x">
          <div className="cell">
            <div className="hero-absolute-image">
              <HeroFullOverlay heroStoreDataKey="ourIngredientsMainHero" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

export default OurIngredients;
